import React from 'react';
import Sponsor from './partials/sponsor';
import _ from 'lodash';

class Sponsors extends React.Component {
    state = {
        microTransac: false,
        sponsors: null
    }
    componentWillMount() {
        const { sponsors, sponsorsActions } = this.props;
        if (!sponsors) this.setState({ microTransac: true }, () => {
            sponsorsActions && sponsorsActions.fetch();
        });
        else this.setState({ sponsors });
    }
    componentWillReceiveProps = nextProps => {
        const { sponsors } = nextProps;
        this.setState({ sponsors, microTransac: false });
    }
    render() {
        const { sponsors } = this.state;
        const chunks = _.chunk(sponsors, 3);
        return <div style={{ minHeight: 300, position: 'relative', overflow: 'hidden' }}>
            {chunks.map((chunk, index) => (
                <div key={index} className="d-flex flex-row w3-content margin-top-double">
                    {chunk.map(sponsor => <Sponsor sponsor={sponsor} key={sponsor.id} />)}
                </div>))}
            <span className="super-hero-text black anton w-100 text-center block" style={{ position: 'absolute', bottom: -100, opacity: 0.20 }}>SPONSORS</span>
        </div>
    }
}

export default Sponsors;


// WEBPACK FOOTER //
// ./src/components/sponsors/index.js